import { SyncLoader, ClipLoader } from "react-spinners";

function LoadingSpinner(props) {
  const {
    useSpinner,
    overRideCss = {
      justifyContent: "center",
      marginTop: "32px",
      marginBottom: "32px",
    },
    color = null,
  } = props;

  return (
    <>
      {!useSpinner && (
        <SyncLoader
          cssOverride={overRideCss}
          color={color ? color : "#36d7b7"}
        />
      )}
      {useSpinner === "ClipLoader" && (
        <ClipLoader
          cssOverride={overRideCss}
          color={color ? color : "#36d7b7"}
        />
      )}
    </>
  );
}

export default LoadingSpinner;
